export const TickIcon = (ps: React.SVGAttributes<SVGElement>) => (
  <svg width="23" height="17" viewBox="0 0 23 17" {...ps}>
    <path
      d="M7.25 13.25L2 8L0.25 9.75L7.25 16.75L22.25 1.75L20.5 0L7.25 13.25Z"
      fill="white"
    />
  </svg>
);
